<sh-autocomplete
    [autocompleteFct]="autocompleteFct"
    [debounce]="autocompleteDebounce"
    [loadingMessage]="autocompleteLoadingMessage"
    [noResultsMessage]="autocompleteNoResultsMessage"
    [lockOnInvalid]="autocompleteLockOnInvalid"
    [invalid]="invalid"
    [inOverflownContainer]="inOverflownContainer"
    (suggestionsSelected)="suggestionsSelected($event)"
>
    <input
        type="text"
        [formControl]="control"
        [id]="id"
        class="sh-input-field sh-form-group__input"
        [attr.autocomplete]="autocomplete || null"
        [attr.placeholder]="message$ | async"
        [attr.aria-describedBy]="invalid ? describeLabelId : null"
        [attr.aria-invalid]="invalid"
        [attr.disabled]="disabled ? true : null"
        [maxlength]="_maxLength"
        [shAutoFocus]="autoFocus"
    />
</sh-autocomplete>
